import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'details',
  templateUrl: './details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryDetailsComponent implements OnInit {
  urlVideos = [];
  @Input() url;

  @Output() detailsEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.detailsEmitter.emit({ status: 'forward' });
  }

  back() {
    this.detailsEmitter.emit({ status: 'backward' });
  }
}
